module.exports = __webpack_public_path__ + "img/w3_location_black.0d4a975a.png";